import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { faBooks } from '@fortawesome/pro-solid-svg-icons'
import { RankmiTable } from '@rankmi/rankmi-table'

import { EnrolState } from 'enum'
import { IMainState } from 'store/states'
import { generateTableLocale } from 'helpers/translations.helper'
import { ExternalCourseEnrolled } from 'models/externalCoursesEnrolled.model'
import styles from './index.module.scss'
import { useColumns } from './hooks/useColumns'
import { useTranslationRankmi, joinKeys } from 'helpers/translations.helper'
import { prefixTranslation } from '../../common'

type Id = ExternalCourseEnrolled['id']

type DataColumn = ExternalCourseEnrolled & {
  key: ExternalCourseEnrolled['id']
  action: Id
}

interface ITable {
  setPage(page: number): void
  setSearch(text: string): void
  setSort: any
  setPerPage(perPage: number): void
  setFastFilters(value: EnrolState | null): void
}

const Table: React.FC<ITable> = ({
  setPage,
  setSearch,
  setSort,
  setPerPage,
  setFastFilters,
}) => {
  const tRelative = useTranslationRankmi({
    prefix: joinKeys(prefixTranslation, 'table.header'),
  })
  const tStatus = useTranslationRankmi({
    prefix: joinKeys('administration.externalCourses', 'participants.status'),
  })

  const [dataSource, setDataSource] = useState<DataColumn[]>([])
  const [translations, setTranslations] = useState<any>({})
  const { list, total, loading } = useSelector(
    ({ externalCoursesEnrolled }: IMainState) => externalCoursesEnrolled
  )

  useEffect(() => {
    setTranslations(() =>
      generateTableLocale({
        header: {
          rowsCount: tRelative('rowsCount'),
          rowsCount_plural: tRelative('rowsCount_plural'),
        },
      })
    )
  }, [tRelative])

  useEffect(() => {
    setDataSource(
      list.map(({ id, ...rest }) => ({
        id,
        key: id,
        ...rest,
        action: id,
      }))
    )
  }, [list])

  const columns = useColumns()
  const { Approved, Denied, Pending } = EnrolState

  const fastActions = [
    { label: tStatus('approved'), value: `${Approved}` },
    { label: tStatus('denied'), value: `${Denied}` },
    { label: tStatus('pending'), value: `${Pending}` },
  ]

  return (
    <div className={styles.container}>
      <RankmiTable
        columnHeaders={columns}
        data={dataSource}
        total={total}
        fastActions={fastActions}
        onPaginationChange={(page: any) => setPage(page)}
        onSearch={(text: string) => setSearch(text)}
        onSortChange={(sortData: any) => setSort(sortData)}
        loading={loading}
        onRowsPerPageChange={setPerPage}
        locale={translations}
        countIcon={faBooks}
        initialRowsPerPage={10}
        simpleSelectAll
        onFastActionSelect={(selected: string | number) => {
          setFastFilters(selected === 0 ? null : +selected)
        }}
        responsive
      />
    </div>
  )
}

export default Table
